<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-integer" v-if="filter">
    <el-dropdown-item>
      <span class="filter-title">{{filter.label}}</span>
      <table border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td class="display-top">Display top</td>
        <td><el-input-number v-model="filter.value" :min="filter.minValue" :max="filter.maxValue" :step="filter.step?filter.step:1" size="mini" controls-position="right"></el-input-number></td>
        <td class="display-top-topics">Topics</td>
      </tr>
      </table>
    </el-dropdown-item>
  </div>
</template>

<script>
export default {
  name: 'wy-filter-item-integer',
  props: ["filter"]
}
</script>

<style lang="scss" scoped>
.wy-header-menu-filtering-panel-ca{
  .el-input-number.is-controls-right .el-input__inner{
    width: 105px !important;
  }
}
</style>